/**
     Rules
    Rule Template {id:'', func: function (scope) {}, _class:'form-url', msg:'', useLabels:false}
*/

// import {passwordSchema} from '../pages/Login';

var Rules = {
    isRequired: {
        name: 'isRequired',
        func: function () {
            let value = this.getValue();
            if (typeof value === 'string') {
                value = value.trim();
            }
            return (value === null) || (value.toString().length > 0);
        },
        msg: 'This value is required.'
    },
    isNumeric: {
        func: function () {
            var re = new RegExp(/^([0-9]\d*(\.|,)\d*|0?(\.|,)\d*[1-9]\d*|[0-9]\d*)$/);
            return re.test(this.getValue());
        },
        msg: 'can only be a number.'
    },
    isInteger: {
        name: 'isInteger',
        func: function () {
            let value = this.getValue();
            return /^[0-9]*$/.test(value);
        },
        msg: 'Can only be a whole number.'
    },
    isEmail: {
        func: function () {
            var re = /^[^\s()<>@,;:/]+@\w[\w.-]+\.[a-z]{2,}$/i;
            return re.test(this._input.value);
        },
        msg: 'Please enter a valid email address.'
    },
    isChecked: {
        name: 'isChecked',
        func: function (scope) {
            return this._input.checked;
        },
        msg: 'You Must Choose an Option'
    },
    isPhone: {
        func: function () {
            var re = /^(1\s*[-/.]?)?(\((\d{3})\)|(\d{3}))\s*[-/.]?\s*(\d{3})\s*[-/.]?\s*(\d{4})\s*(([xX]|[eE][xX][tT])\.?\s*(\d+))*$/;
            return re.test(this._input.value);
        },
        msg: 'You must enter a valid phone number.'
    },
    isLength: {
        name: 'isLength',
        func: function () {
            var str = this.getValue().toString().trim();
            var min = parseInt(this.props.min, 10) || 1;
            var max = parseInt(this.props.max, 10) || Infinity;
            if (min === max) {
                return (str.length === min);
            }
            return (str.length >= min) && (str.length <= max);
        },
        msg: 'you must only enter ## characters'
    },
    noWhiteSpace: {
        name: 'noWhiteSpace',
        func: function () {
            let initString = this.getValue().toString();
            let trimmedString = initString.trim();
            if (initString.length > trimmedString.length) {
                return false;
            }
            return true;
        },
        msg: 'Please remove unnecessary spaces.'
    },
    isURL: {
        func: function () {
            var re = /(https?:\/\/)?(www\.)?([a-zA-Z0-9_%-]*)\b\.[a-z]{2,4}(\.[a-z]{2})?((\/[a-zA-Z0-9_%-]*)+)?(\.[a-z]*)?/;
            return re.test(this._input.value);
        },
        msg: 'Please enter a valid URL.'
    },
    matches: {
        func: function () {
            return this.props.compare().getValue() === this._input.value;
        },
        msg: 'Fields do not match.'
    },
    isISBN: {
        func: function () {
            // ISBN Pattern from http://html5pattern.com/Miscs
            const re = /(?:(?=.{17}$)97[89][ -](?:[0-9]+[ -]){2}[0-9]+[ -][0-9]|97[89][0-9]{10}|(?=.{13}$)(?:[0-9]+[ -]){2}[0-9]+[ -][0-9Xx]|[0-9]{9}[0-9Xx])/;
            return re.test(this.getValue());
        },
        msg: 'Please enter a valid ISBN'
    },
    maxWordLength: {
        name: 'maxWordLength',
        func: function () {
            let maxWords = parseInt(this.props.maxWords, 10);
            let wordCount = this.getValue().split(' ').length;

            if (wordCount > maxWords) {
                return false;
            }
            return true;
        },
        msg: 'Exceeds maximum number of words.'
    },
    hasSelected: {
        func: function () {
            return this.getValue().length > (this.props.min || 0);
        },
        msg: 'You must select an option.'
    },
    // validPassword: {
    //     func: function () {
    //         return passwordSchema.validate(this.getValue());
    //     },
    //     msg: 'Password does not meet requirements.'
    // }
};

export default Rules;
